import { Link } from "react-router-dom";
import { formatPrice } from "@/lib/api";
import { StarDisplay } from "@/components/reviews/StarRating";
import WishlistButton from "@/components/WishlistButton";

export default function ProductCard({ product }) {
  const img = product.default_image || product.images?.[0]?.src;
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group relative block border border-border bg-white rounded-sm overflow-hidden transition-transform hover:-translate-y-1 hover:shadow-md"
    >
      <WishlistButton productId={product.id} />
      <div className="aspect-square bg-muted overflow-hidden">
        {img ? (
          <img
            src={img}
            alt={product.title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-muted-foreground text-xs">No image</div>
        )}
      </div>
      <div className="p-4 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="font-display text-base leading-snug truncate">{product.title}</h3>
          <div data-testid={`product-card-rating-${product.id}`} className="flex items-center gap-1.5 mt-1.5">
            <StarDisplay value={product.rating_avg || 0} size={13} />
            <span className="text-xs text-foreground/60">
              {product.rating_count ? `${product.rating_avg.toFixed(1)} (${product.rating_count})` : "No reviews yet"}
            </span>
          </div>
          <p className="text-xs uppercase tracking-widest text-muted-foreground mt-1">
            {product.category || "General"}
          </p>
        </div>
        <div className="text-right whitespace-nowrap">
          <span className="font-display text-base text-[#C84A31]">
            {product.min_price != null ? formatPrice(product.min_price) : "—"}
          </span>
          {product.min_price != null && <span className="text-xs text-muted-foreground">+</span>}
        </div>
      </div>
    </Link>
  );
}
